import React from 'react';
import { AuditLogProvider } from '../store/auditLogContext';
import AuditLogList from '../components/AuditLog/AuditLogList';

const AuditLogPage: React.FC = () => (
    <AuditLogProvider>
        <AuditLogList />
    </AuditLogProvider>
);

export default AuditLogPage;
